import React from 'react';
import { useAIChat } from '../../context/AIChatContext';
import { SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline';

const AIChatToggleButton = () => {
  const { isOpen, togglePanel } = useAIChat();

  const styles = {
    button: {
      position: 'fixed',
      bottom: '1.5rem',
      right: '1.5rem',
      width: '3.5rem',
      height: '3.5rem',
      borderRadius: '50%',
      backgroundColor: isOpen ? 'var(--gray-600)' : 'var(--primary-600)',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
      transition: 'all 0.3s ease',
      zIndex: 997,
      transform: 'scale(1)'
    },
    icon: {
      width: '1.75rem',
      height: '1.75rem',
      transition: 'transform 0.3s ease'
    },
    tooltip: {
      position: 'absolute',
      right: '100%',
      top: '50%',
      transform: 'translateY(-50%)',
      marginRight: '0.75rem',
      padding: '0.5rem 0.75rem',
      backgroundColor: 'var(--gray-900)',
      color: 'white',
      fontSize: '0.75rem',
      fontWeight: '500',
      borderRadius: '0.375rem',
      whiteSpace: 'nowrap',
      opacity: 0,
      visibility: 'hidden',
      transition: 'opacity 0.2s, visibility 0.2s',
      pointerEvents: 'none'
    },
    kbd: {
      display: 'inline-block',
      padding: '0.125rem 0.375rem',
      marginLeft: '0.5rem',
      fontSize: '0.625rem',
      fontFamily: 'monospace',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      borderRadius: '0.25rem'
    }
  };

  return (
    <button
      style={styles.button}
      onClick={togglePanel}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        const tooltip = e.currentTarget.querySelector('.tooltip');
        if (tooltip) {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        const tooltip = e.currentTarget.querySelector('.tooltip');
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
        }
      }}
      title={isOpen ? 'Close AI Assistant' : 'Open AI Assistant (Ctrl+Shift+A)'}
    >
      {isOpen ? (
        <XMarkIcon style={styles.icon} />
      ) : (
        <SparklesIcon style={{ ...styles.icon, transform: 'rotate(-15deg)' }} />
      )}
      <span className="tooltip" style={styles.tooltip}>
        {isOpen ? 'Close Assistant' : 'AI Assistant'}
        <span style={styles.kbd}>Ctrl+Shift+A</span>
      </span>
    </button>
  );
};

export default AIChatToggleButton;
